<dp-sre-gantt-value *ngFor="let value of scaleValues" [value]="value"></dp-sre-gantt-value>
